// Module
var code = "<div class=\"sb-deliverable-date-info\" ng-click=\"$ctrl.editDates()\"> <div ng-transclude></div> </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/deliverables/sbDeliverableDetails/sbDeliverableDates/sb_dates.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;